import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  OwnerSummary,
  OwnerSummaryDto,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.owner}owners`;

interface GetOwnersQueryPayload {
  tenantId: string;
  sellerId: string;
  email?: string;
  name?: string;
  phoneNumber?: string;
  zipCode?: string;
  externalId?: string;
}

async function getOwnersQuery({
  tenantId,
  email,
  phoneNumber,
  zipCode,
  sellerId,
  name,
  externalId,
}: GetOwnersQueryPayload): Promise<
  BackResponse<OwnerSummary[]> | BackResponseFailure
> {
  try {
    return await apiCall<BackResponse<OwnerSummaryDto[]>>(
      buildUrl(ENDPOINT, {
        tenantId,
        mail: email,
        phoneNumber,
        zipCode,
        sellerId,
        name,
        externalId,
      }),
      {
        method: SUPPORTED_METHODS.GET,
      },
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
}

export default getOwnersQuery;
